module.exports = __webpack_public_path__ + "gu.6fc7b410a6c3e77c2a90.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gu.svg
// module chunks = styles